import React, { useState, useEffect } from 'react';
import { Info, X,  } from 'lucide-react';
import { useHistory, useParams } from "react-router-dom";
import Tooltip from './Tooltip';
import { Routes } from '../../routes';
import apiHelper from '../../apiHelper';
import DiscardConfirmationModal from '../../components/DiscardConfirmationModal';
export default function EditDepartment() {
    let { id } = useParams();
    const history = useHistory();
    const [disabled, setDisabled] = useState(false);
    const [validationError, setValidationError] = useState([]);
    const [successMessage, setSuccessMessage] = useState('');
    const [departments, setDepartment] = useState([]);

    const [formData, setFormData] = useState({
        department_name: '',
        short_name: '',
        status: '1',
        notes: '',
        parent_id: '',
        supervisor_id: ''
    });

    const [errors, setFormErrors] = useState({
        department_name: '',
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    useEffect(() => {
        async function fetchData() {
            const response = await apiHelper('departments/list/');
            if (response && response.ok) {
                const result = await response.json();
                const data = result.filter(item => item.department_id != id);
                setDepartment(data);
            }
        }

        async function fetchDepartment() {
            const response = await apiHelper(`departments/show/${id}/`, 'GET');
            if (response && response.ok) {
                const result = await response.json();
                setFormData({
                    department_name: result.department_name,
                    short_name: result.short_name,
                    status: result.status,
                    notes: result.notes,
                    parent_id: result.parent,
                    supervisor_id: result.supervisor_id
                });
            }
        }

        async function loadAll() {
            try {
                await fetchDepartment();
                await fetchData();
            } catch (error) {
                console.error('Failed to load department data:', error);
            }
        }

        loadAll();
    }, []); // Empty dependency array ensures the effect runs only once

    const handleSave = async () => {

        setDisabled(true);
        let form_errors = { department_name: '', short_name: '' };
        let is_error = false;
        if (!formData.department_name) {
            form_errors["department_name"] = "This field is required!";
            is_error = true;
        }

        setFormErrors(form_errors);
        if (is_error) {
            setDisabled(false);
            return false;
        }

        try {
            const response = await apiHelper(`departments/update/${id}/`,'POST', formData);
            setDisabled(false);

            if (response) {
                if (response.ok) {
                    setSuccessMessage('Department updated successfully.');
                    setValidationError([]);
                }
                else if (response.status == 400) { //for validation error
                    const response_errors = await response.json();
                    let errors = [];
                    for (let i in response_errors) {
                        errors.push(`${i}: ${response_errors[i][0]}`);
                    }
                    setValidationError(errors);
                    setSuccessMessage('');
                }
            }
        } catch (error) {
            console.error('Failed to save department:', error);
        }
    };

     const [discardModalOpen, setDiscardModalOpen] = useState(false);
           const handleDiscard = () => {
            setDiscardModalOpen(true);
        };
        const handleDiscardConfirm = (confirm) => {
            if (confirm) {
                history.goBack();
            }
            setDiscardModalOpen(false);
        };
        const handleCancelDiscard = () => {
            setDiscardModalOpen(false);
        };

    const [activeTab, setActiveTab] = useState("Edit Departments");

    const breadcrumbs = [
        "Organisations",
        "Departments",
        activeTab
    ];

    return (
        <>
            <div className="company-body main-company-body-inner">
                <div className="breadcrumb">
                    {breadcrumbs.map((crumb, index) => {
                        const isLast = index === breadcrumbs.length - 1;
                        return (
                            <span
                                key={index}
                                className={`breadcrumb-item ${crumb === "Departments" ? "clickable" : ""}`}
                                onClick={() => {
                                    if (crumb === "Departments") {
                                        history.push(Routes.Department.path);
                                    }
                                }}
                                style={{ cursor: crumb === "Departments" ? "pointer" : "default" }}
                            >

                                {crumb}
                                {!isLast ? "  " : ""}
                            </span>
                        );
                    })}
                </div>

                {successMessage && (
    <div
        className="d-flex align-items-center justify-content-between"
        role="alert"
        style={{
            boxShadow: "0px 4px 10px 0px #0000001F",
            padding: "15px 10px",
            borderRadius: "12px",
            border: "1px solid #28a745",   // green border
            backgroundColor: "#d4edda",    // light green background
            color: "#155724",              // dark green text
            fontSize: "12px",
            position: "fixed",
            top: "10px",
            width: "calc(100% - 20px)",
            maxWidth: "640px",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 2000,
        }}
    >
        <div className="d-flex align-items-center" style={{ gap: "6px" }}>
            <strong>{successMessage}</strong>
        </div>

        <X
            size={16}
            style={{ cursor: "pointer" }}
            onClick={() => setSuccessMessage("")}
        />
    </div>
)}


                <div className='edit-organisation-info'>
                    <div className='edit-organisation-left'>
                        <h1>Edit Department</h1>
                    </div>
                    <div className='discard-save-organisation-right d-flex align-items-center gap-2'>
                        <button className="dark-button" type='button' onClick={handleDiscard}>Discard</button>
                         <DiscardConfirmationModal
                            isOpen={discardModalOpen}
                            onCancel={handleCancelDiscard}
                            onConfirm={handleDiscardConfirm}
                            entityName="Department"  // 🔁 Change dynamically (e.g., “Category”, “Stock”)
                        />
                        <button className="dark-border" type='button' onClick={handleSave} disabled={disabled}>Save</button>
                    </div>
                </div>

                <div className="info-section">
                    <div className="info-card new-info-overflow-auto">
                        <div className="info-header">
                            <h4 className="info-title">Department Info</h4>
                        </div>
                        <div className="info-content d-block">
                            <div className='grid-info-adding'>

                                {successMessage && <div style={{ color: 'green' }} className="success-message">{successMessage}</div>}

                                <ul style={{ color: 'red' }}>
                                    {validationError && validationError.map((error, index) => (
                                        <li key={index}>{error}</li>
                                    ))}
                                </ul>

                                <div className='row gappingcls-added'>
                                    <div className='col-lg-6 col-md-6 col-12'>
                                        <div className="info-inner">
                                            <label htmlFor="department_name" className="form-label">
                                                Department Name <span className='error-color'>*</span>
                                            </label>
                                            <input type="text" className="form-control common-input-all" id="department_name" placeholder="Department Name" name="department_name" value={formData.department_name} onChange={handleChange} />
                                            {errors.department_name && <p style={{ color: 'red' }}>{errors.department_name}</p>}
                                        </div>
                                    </div>
                                    <div className='col-lg-6 col-md-6 col-12'>
                                        <div className="info-inner">
                                            <label htmlFor="status" className="form-label">
                                                Status <span className='error-color'>*</span>
                                            </label>
                                            <div className='flexing-type-radio'>
                                                <div className="form-check">
                                                    <input className="form-check-input" type="radio" value="1" checked={formData.status == '1'} name="status" onChange={handleChange} id="flexRadioDefault1" />
                                                    <label className="form-check-label" htmlFor="flexRadioDefault1">
                                                        Active
                                                    </label>
                                                </div>
                                                <div className="form-check">
                                                    <input className="form-check-input" type="radio" value="0" checked={formData.status == '0'} name="status" onChange={handleChange} id="flexRadioDefault2" />
                                                    <label className="form-check-label" htmlFor="flexRadioDefault2">
                                                        Inactive
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='row gappingcls-added'>
                                    <div className='col-lg-6 col-md-6 col-12'>
                                        <div className="info-inner">
                                            <label htmlFor="id" className="form-label d-flex align-items-center gap-2">
                                                Short Name
                                                <Tooltip content="A shorter, human-friendly label for your entity">
                                                    <Info size={16} className="info-icon" />
                                                </Tooltip>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control common-input-all"
                                                id="id"
                                                placeholder="Short Name"
                                                name="short_name"
                                                onChange={handleChange}
                                                value={formData.short_name}
                                            />
                                            {errors.short_name && <p style={{ color: 'red' }}>{errors.short_name}</p>}
                                        </div>
                                    </div>
                                    <div className='col-lg-6 col-md-6 col-12'>
                                        <div className="info-inner">
                                            <label htmlFor="parentdepartment" className="form-label d-flex align-items-center gap-1">
                                                Parent Department
                                                <Tooltip content="Human-friendly label for your entity">
                                                    <Info size={16} className="info-icon" />
                                                </Tooltip>
                                            </label>
                                            <select className="form-select new-form-select-cls" name="parent_id" value={formData.parent_id} onChange={handleChange} aria-label="Default select example">
                                                <option defaultValue>Select Parent Department</option>
                                                {departments && departments.map((item, index) => (
                                                    <option key={index} value={item.department_id}>{item.department_name}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div className='row gappingcls-added'>
                                    <div className='col-lg-6 col-md-6 col-12'>
                                        <div className="info-inner">
                                            <label htmlFor="parentEntity" className="form-label d-flex align-items-center gap-1">
                                                Supervisor
                                                <Tooltip content="Friendly label for your entity">
                                                    <Info size={16} className="info-icon" />
                                                </Tooltip>
                                            </label>
                                            <select name="supervisor_id" value={formData.supervisor_id} onChange={handleChange} className="form-select new-form-select-cls" aria-label="Default select example">
                                                <option defaultValue>Select Supervisor</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="info-card">
                        <div className="info-header">
                            <h4 className="info-title">Additional Info</h4>
                        </div>
                        <div className="info-content">
                            <div className="info-inner common-textarea">
                                <label htmlFor="exampleFormControlTextarea1" className="form-label">Note</label>
                                <textarea className="form-control w-100 common-textarea-all" name="notes" value={formData.notes} onChange={handleChange} id="exampleFormControlTextarea1" rows="3"></textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
